<template>
  <el-row>
    <el-col :span="24">
      <el-card class="login" shadow="always">
        <div slot="header" class="login__header">
<!--          <img id="logo" src="@/assets/images/logo_blue.svg" />-->
          Forgot password
        </div
        >
        <div class="recover-instructions">
          <p>
            Follow the steps to recover your account. You'll be asked some
            questions to confirm it's your account and an email will be sent to
            you. If you don’t get an email:
          </p>
          <ul>
            <li>
              Check your Spam or Bulk Mail folders
            </li>
            <li>
              Add support@syncvault.com to your address book.
            </li>
            <li>
              Follow the steps to recover your account.
            </li>
            <li>
              Check all email addresses you might have used to sign up or sign in
              to your account.
            </li>
          </ul>
        </div>
        <div>
          <el-form ref="form" :model="form" @submit.prevent="passwordReset">
            <el-form-item>
              <el-input
                placeholder="Email"
                v-model.trim="form.email"
                @keyup.enter.native="passwordReset(form)"
                required
                name="email"
              />
            </el-form-item>
            <p v-if="forgotPasswordErrors && forgotPasswordErrors.email" class="error-msg">
              {{ forgotPasswordErrors.email[0] }}
            </p>
          </el-form>
          <div class="login__footer">
            <router-link to="/auth/login">
              Back to login page
            </router-link>
            <el-button
              type="primary"
              class="btn-main"
              :loading="loading"
              @click="passwordReset(form)"
            >
              Send Reset Link
            </el-button>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      form: {
        email: '',
        site: 'admin'
      }
    }
  },

  computed: {
    ...mapState('auth', ['loading', 'forgotPasswordErrors'])
  },

  methods: {
    ...mapActions('auth', ['passwordReset'])
  }
}
</script>

<style lang="scss" scoped>

.login {
  margin: 17vh auto;
  width: auto;
  max-width: 25rem;
  max-height: 34rem;
  text-align: center;

  .login__header{
    font-size: 2rem;
  }
  .recover-instructions{
    text-align: left;
    ul li{
      font-weight: bold;
      font-size: 15px;
    }
  }

  #logo {
    width: 180px;
    padding-right: 1rem;
    vertical-align: middle;
  }

  &__header {
    padding: 15px 20px;
  }

  &__footer {
    margin: 40px 0 15px;
    display: flex;
    justify-content: space-between;

    a {
      font-size: 14px;
    }
  }
}

@media screen and (max-width: 800px) and (orientation: landscape) {
  .login {
    margin: 5vh auto;
  }
}

</style>
